/* eslint-disable react/prop-types */
import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const ErrorMessage = ({ error, onDismiss }) => (
  <div className="ai-chat-widget-error">
    <span>{error}</span>
    <IconButton size="small" onClick={onDismiss}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </div>
);

export default ErrorMessage;

